import { render, staticRenderFns } from "./UploadButton.vue?vue&type=template&id=b0f0288c&scoped=true"
import script from "./UploadButton.vue?vue&type=script&lang=js"
export * from "./UploadButton.vue?vue&type=script&lang=js"
import style0 from "./UploadButton.vue?vue&type=style&index=0&id=b0f0288c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f0288c",
  null
  
)

export default component.exports